export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="text-2xl font-heading font-black text-primary-500 no-underline whitespace-nowrap">
                春色影视
              </a>
              <p className="mt-4 text-sm leading-relaxed text-foreground-400 max-w-xs">
                春色影视提供高清免费在线观看服务，海量电影电视剧全集，无需缓冲流畅播放，免费不收费，最新影视持续更新，致力于为全球华人打造最优质的免费观影体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-200 mb-4 whitespace-nowrap">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">焦点专题</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">热播榜单</a></li>
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">影视索引</a></li>
                <li><a href="#media" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">精彩预告</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-200 mb-4 whitespace-nowrap">帮助中心</h4>
              <ul className="space-y-2.5">
                <li><a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">联系我们</a></li>
                <li><a href="#about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">关于我们</a></li>
                <li><a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer">更新快讯</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-200 mb-4 whitespace-nowrap">合作伙伴</h4>
              <p className="text-sm text-foreground-500">更多合作伙伴即将入驻</p>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 春色影视. 本站所有内容仅供学习交流，请于下载后24小时内删除。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline cursor-pointer">回到顶部</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}